
(function () {
    var select = $("#product-title");
  var options = select.find("option");
  
  options.sort(function(a, b) {
  
    var dateA = new Date($(a).attr("date"));
    var dateB = new Date($(b).attr("date"));
      return dateB - dateA;  
  });

  select.empty();

  options.each(function() {
    let date = new Date($(this).attr("date"));
    let dateNow = new Date();
    if(date < dateNow)
    select.append($(this));
  });

 select.val($('#product-title option:first').val())
  
  $('#modal-certificate-new .modal__close.link').click(function(e) {
  e.preventDefault();
  
 $('#modal-certificate-new').attr('aria-hidden', true);
})
$('.download-certificate-btn').click(function(e) {
  e.preventDefault();
  
 $('#modal-certificate-new').attr('aria-hidden', false);
})
  // $("#content2").addClass('ml-215'); // JS solution for smaller screen but better to add media queries to tackle the issue
  $('.form__submit__certificate').click(function(e) {
      $('#cert-container-pdf').removeClass('hideMe');
     $('.alert.alert--error').addClass('hideMe');

        var updatedData = {
      customer: {
        id: $('#customer-id').val(),
        email: $('#customer-email').val(),
        note: 'testing'
      }
    };


    
  const password = $('#password').val();
  var selectedOption = $('#product-title option:selected');
  var codeAttribute = selectedOption.attr('code');
  var subtitle = selectedOption.attr('subtitle');
  var Producttitle =$('#product-title').val();
  var producttitletag = subtitle.split(" ").join("-")
  var date = selectedOption.attr('date');
  const customerName = $('#customer-name').val();
  const title = $('#title').val();
  const institute = $('#institution').val();
  if(institute.length <= 0 || title.length <=0 || password.length <= 0) {
    $('.alert__error-item').html('Please make sure all the field are not empty')
    $('.alert.alert--error').removeClass('hideMe');
    return;
  }
  if(password != codeAttribute)  {
     $('.alert__error-item').html("Password Didn't Match")
    $('.alert.alert--error').removeClass('hideMe');
    return;
  }
    $('#cert-container-pdf .webinarySubtitle').html(subtitle);
     $('#cert-container-pdf .date').html(date);
     $('#cert-container-pdf .webinaryName').html(Producttitle);
     $('#cert-container-pdf .institutionName').html(institute);
    
 
    const params = {
      id: $('#customer-id').val(),
      tags: `title-${title}, institution-${institute}, certificate`
    }
    $.ajax({
      url: 'https://paper-clip-taggerf.gadget.app/tags',
      method: 'post',
      data: params,
      success: function(response) {
        console.log('Customer account updated successfully:', response);
        // Optionally, perform any other actions or show success message
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error('Error updating customer account:', errorThrown);
        // Optionally, display an error message to the user
      }
    });
      html2pdf(document.getElementById('cert-container-pdf'), {
        margin: [0,0,0,0],
        filename: "paperclip-certificate.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { dpi: 500, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      }).then(function() {
     $('#modal-certificate-new').attr('aria-hidden', true);
       $('#cert-container-pdf').addClass('hideMe');
  })

   
  })

  if (window.location.reload){
    const data2 = { 
      attributes: {
        'password': ''
      } 
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data2),
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  var button = document.getElementById('password-protection');
  var password = '';
 if(button) { 
  button.addEventListener("click", () => {
      password = document.getElementById('password-protection-input').value;
      const data = { 
        attributes: {
          'password': password
        } 
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });
 }
})();

//  * Include your custom JavaScript here.
//  *
//  * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
//  * changes on product page, you can attach a listener to the document:
//  *
//  * document.addEventListener('variant:changed', function(event) {
//  *   var variant = event.detail.variant; // Gives you access to the whole variant details
//  * });
//  *
//  * You can also add a listener whenever a product is added to the cart:
//  *
//  * document.addEventListener('product:added', function(event) {
//  *   var variant = event.detail.variant; // Get the variant that was added
//  *   var quantity = event.detail.quantity; // Get the quantity that was added
//  * });
//  *
//  * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
//  * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
//  * that was added so the theme can properly update the quantity:
//  *
//  * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
//  *   bubbles: true,
//  *   detail: {
//  *     quantity: 1
//  *   }
//  * }));
//  *
//  * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
//  * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
//  *
//  * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//  *   bubbles: true
//  * }));
